import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  createDeliveryAddress,
  updateDeliveryAddress,
  deleteDeliveryAddress
} from 'Redux/addresses/addressesThunks';
import { t } from 'Utils/localization/i18next';
import { InlineAlert } from 'Common';
import { showToast } from 'Utils/toastUtils';
import { clearFormAction } from 'Redux/forms/formsActions';
import DeliveryAddresses from 'Components/Dashboard/ShippingBillingAddresses/DeliveryAddresses';

class DeliveryAddressFieldReadContainer extends React.PureComponent {
  onCreate = async (data, successCallback, failureCallback) => {
    const { addForm } = this.props;
    const success = await this.props.createDeliveryAddress(data, addForm);

    if (!success) {
      if (failureCallback) {
        failureCallback();
      }
      return;
    }
    if (successCallback) {
      successCallback();
    }
    showToast(
      t('dashboard.confirmation.addressDeliverySectionCreateTitle'),
      t('dashboard.confirmation.addressDeliverySectionCreateText')
    );
  };

  onUpdate = async (data, successCallback, failureCallback) => {
    const { editForm } = this.props;
    const success = await this.props.updateDeliveryAddress(data, editForm);

    if (!success) {
      if (failureCallback) {
        failureCallback();
      }
      return;
    }
    if (successCallback) {
      successCallback();
    }
    showToast(
      t('dashboard.confirmation.addressDeliverySectionUpdateTitle'),
      t('dashboard.confirmation.addressDeliverySectionUpdateText')
    );
  };

  onDelete = async (addressId, successCallback, failureCallback) => {
    const { editForm } = this.props;
    const success = await this.props.deleteDeliveryAddress(addressId, editForm);

    if (!success) {
      if (failureCallback) {
        failureCallback();
      }
      return;
    }
    if (successCallback) {
      successCallback();
    }
    showToast(
      t('dashboard.confirmation.addressDeliverySectionDeleteTitle'),
      t('dashboard.confirmation.addressDeliverySectionDeleteText')
    );
  };

  render() {
    return (
      <React.Fragment>
        {this.props.deliveryAddressesFailed ? (
          <InlineAlert
            title="dashboard.address.loadingFailedTitle"
            text="dashboard.address.loadingFailedText"
            marginBottom="m"
          />
        ) : (
          <DeliveryAddresses
            deliveryAddresses={this.props.deliveryAddresses}
            rows={this.props.rows}
            secondRows={this.props.secondRows}
            name={this.props.name}
            contactTypes={this.props.contactTypes}
            icon={this.props.icon}
            editForm={this.props.editForm}
            onUpdate={this.onUpdate}
            onDelete={this.onDelete}
            clearFormAction={this.props.clearFormAction}
            maskRules={this.props.maskRules}
            title={this.props.title}
          />
        )}
      </React.Fragment>
    );
  }
}

DeliveryAddressFieldReadContainer.propTypes = {
  icon: PropTypes.string.isRequired,
  addForm: PropTypes.string,
  editForm: PropTypes.string,
  name: PropTypes.arrayOf(PropTypes.string),
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  secondRows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  contactTypes: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  titleAdd: PropTypes.string,
  deliveryAddresses: PropTypes.arrayOf(PropTypes.object),
  deliveryAddressesFailed: PropTypes.bool,
  createDeliveryAddress: PropTypes.func.isRequired,
  updateDeliveryAddress: PropTypes.func.isRequired,
  deleteDeliveryAddress: PropTypes.func.isRequired,
  clearFormAction: PropTypes.func.isRequired,
  maskRules: PropTypes.object
};

const mapStateToProps = state => {
  return {
    deliveryAddressesFailed: state.addresses.deliveryAddressesFailed,
    deliveryAddresses: state.addresses.deliveryAddresses
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      createDeliveryAddress,
      updateDeliveryAddress,
      deleteDeliveryAddress,
      clearFormAction
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeliveryAddressFieldReadContainer);
